import { useUpdateProp } from 'client/components/core/Sidebar/components/Settings/hooks/useUpdateProps'
import { useDeviceModeContext } from 'client/context/DeviceModeContext'
import { BackgroundInterface } from 'common/types/background-interfaces'
import { getMobileBackgroundFileId } from 'common/utils/getMobileBackgroundFileId'
import React from 'react'
import { HorizontalLine } from 'src/editor/layout/sidebar/settings/horizontal-line'
import { ImageControl } from 'src/editor/shared/settings/controls/image-control'
import { RangeElement } from 'src/editor/shared/ui-lib/range-element'
import { useTypedTranslation } from 'src/shared/i18next/hooks/use-typed-translation'
import { WebsiteLogoInterface } from 'src/shared/types/entities/website-logo-interface'
import { getMobileOrDesktop } from 'src/shared/utils/get-mobile-or-desktop'
import { WebsiteLogoSettingsLink } from './website-logo-settings-link'

interface WebsiteLogoSettingsImageProps {
  entity: WebsiteLogoInterface
}

export const WebsiteLogoSettingsImage = ({
  entity,
}: WebsiteLogoSettingsImageProps) => {
  const updateProp = useUpdateProp(entity)
  const { t } = useTypedTranslation()
  const { isMobile } = useDeviceModeContext()
  const getImageLabel = (): string => {
    return isMobile
      ? 'website_settings.sidebar.logo.mobile_image'
      : 'website_settings.sidebar.logo.label'
  }
  const getFileId = (): BackgroundInterface['backgroundFileId'] => {
    return isMobile
      ? getMobileBackgroundFileId(entity.logoFileId, entity?.mobileLogoFileId)
      : entity.logoFileId
  }
  return (
    <>
      <ImageControl
        className="mt-3"
        label={getImageLabel()}
        fileId={getFileId()}
        updateBackgroundFileId={updateProp(
          isMobile ? 'mobileLogoFileId' : 'logoFileId',
        )}
      />
      <p className="mt-3! text-M text-textTertiary">
        {t('website_settings.sidebar.logo.description')}
      </p>
      <WebsiteLogoSettingsLink
        url={entity.logoLink || ''}
        setUrl={updateProp('logoLink')}
      />
      <HorizontalLine />
      <RangeElement
        label="components.website_logo.settings.height.label"
        onChange={updateProp(isMobile ? 'mobileHeight' : 'height')}
        value={getMobileOrDesktop(entity.height, entity.mobileHeight, isMobile)}
        max={150}
        allowNegative={false}
      />
    </>
  )
}
